"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFieldAlign = exports.Input = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _input = require("./input.tokens");
var InputFieldAlign = exports.InputFieldAlign = /*#__PURE__*/function (InputFieldAlign) {
  InputFieldAlign["LEFT"] = "left";
  InputFieldAlign["RIGHT"] = "right";
  InputFieldAlign["CENTER"] = "center";
  return InputFieldAlign;
}({});
var Input = exports.Input = _styledComponents.default.input.withConfig({
  displayName: "Inputcommon__Input",
  componentId: "sc-13t4jmp-0"
})(["display:flex;align-items:center;text-align:", ";height:", ";width:", ";padding:", " ", ";background-color:", ";border:", ";border-radius:", ";", ";-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;outline:none;color:", ";", " ", " ::placeholder{color:", ";}"], function (_ref) {
  var align = _ref.align;
  return align ? align : 'left';
}, function (_ref2) {
  var height = _ref2.height;
  return _input.tokens.size.height[height];
}, function (_ref3) {
  var width = _ref3.width;
  return _input.tokens.size.width[width];
}, _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['400'], _input.tokens.color.background.default, _input.tokens.border.default, _input.tokens.borderRadius, function (props) {
  return props.theme.sys.font.body['1'];
}, _globalTokens.globalColor.text.content.main, function (_ref4) {
  var hasError = _ref4.hasError;
  return hasError && (0, _styledComponents.css)(["border:", ";"], _input.tokens.border.error);
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && (0, _styledComponents.css)(["pointer-events:none;background-color:", ";border:", ";"], _input.tokens.color.background.disabled, _input.tokens.border.disabled);
}, _globalTokens.globalColor.text.content.main);